import { useTranslation } from '@flecto/translations'
import { type CoreCountryCode } from '@flecto/types'

export function useGetCountryName() {
  const { t } = useTranslation('shared', { keyPrefix: 'countries' })

  return (country?: CoreCountryCode) => {
    if (!country) {
      return ''
    }

    return t(country)
  }
}
